export const TRACK_EVENTS={
    LOCAL_TRACK_ADDED:"local.track.added",
    LOCAL_TRACK_REMOVED:"local.track.removed",
    LOCAL_TRACK_MUTE_CHANGED:"local.track.mute.changed",
    REMOTE_TRACK_ADDED:"remote.track.added",
    REMOTE_TRACK_REMOVED:"remote.track.removed",
    REMOTE_TRACK_MUTE_CHANGED:"remote.track.mute.changed",
    SCREEN_SHARE_TRACK_ADDED:"screenshare.track.added",
    SCREEN_SHARE_TRACK_REMOVED:"screenshare.track.removed",
    SCREEN_SHARE_TRACK_MUTE_CHANGED:"screenshare.track.mute.changed",
    VIDEO_SUSPENDED:'remote.video.suspended',
    VIDEO_RESUMED:'remote.video.resumed',
    TRACK_STATUS_CHANGED:'remote.video.status.changed'
};

export const MEDIA_TYPE={
    AUDIO:"audio",
    VIDEO:"video",
    SCREENSHARE:"screenshare",
    DESKTOP:"desktop"
};

export const VIDEO_TYPE={
    CAMERA:"camera",
    DESKTOP:"desktop"
};

export const STREAMING_STATUS={
        /**
         * Status indicating that streaming is currently active.
         */
        ACTIVE:'active',

        /**
         * Status indicating that streaming is currently inactive.
         * Inactive means the streaming was stopped on purpose from the bridge, like exiting forwarded sources or
         * adaptivity decided to drop video because of not enough bandwidth.
         */
        INACTIVE :'inactive',

        /**
         * Status indicating that streaming is currently interrupted.
         */
        INTERRUPTED:'interrupted',

        /**
         * Status indicating that streaming is currently restoring.
         */
        RESTORING:'restoring'
}
